import Set from "core-js-pure/actual/set";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { BasicSpinner } from "@action.sustainability/storybook-dashboard/spinners/basicSpinner";

import useApi, {
  fetcher,
  doFetch,
} from "@action.sustainability/storybook-dashboard/utils/fetching";
import Octicon from "react-octicon";
import Im from "immutable";

import FileSaver from "file-saver";

import { Modal, useModal, ClearModal } from "../modal";

import { CCP_API_URL } from "../fetching";
import { CatalogTable } from "./catalogTable";
import exportToXLS from "./exportToXLS";

const updateShares = ({ companyId, onSuccess, product, shares }) => {
  console.log("updateShares", companyId, product, shares);

  const setShares = new Set(shares.map(({ uid }) => uid));
  const setCurrentShars = new Set(product.shares);
  const sharesToAdd = setShares.difference(setCurrentShars);
  const sharesToDelete = setCurrentShars.difference(setShares);

  Array.from(sharesToAdd).map(async (companyToAdd) => {
    await fetcher(
      `${CCP_API_URL}/${companyId}/product/product/${product.product_id}/share/company/${companyToAdd}`,
      "POST",
    );
  });
  Array.from(sharesToDelete).map(async (companyToDelete) => {
    await fetcher(
      `${CCP_API_URL}/${companyId}/product/product/${product.product_id}/share/company/${companyToDelete}`,
      "DELETE",
    );
  });
  onSuccess();
};

function SharesList({ shares, setShares }) {
  console.log("SharesList", shares.toJS());
  const rows = shares.toList().map((share, i) => (
    <tr key={i}>
      <td>
        {share.get("name")}
        <span
          style={{ cursor: "pointer" }}
          className="badge badge-secondary float-right"
          onClick={() => setShares(shares.delete(share.get("uid")))}
        >
          Remove
        </span>
      </td>
    </tr>
  ));
  return (
    <table className="table table-sm table-striped">
      <tbody>{rows}</tbody>
    </table>
  );
}

function ShareProductModal({ companyId, product, onSuccess }) {
  const { setModal } = useModal();
  const { data: clients, isLoading: isLoadingClients } = useApi(`/api/client/`);
  const [shares, setShares] = useState(Im.Map());
  console.log(
    "ShareProductModal",
    product.shares,
    clients?.toJS(),
    shares?.toJS(),
  );

  const _onSuccess = () => {
    setModal(<ClearModal />);
    if (onSuccess) {
      onSuccess();
    }
  };

  useEffect(() => {
    if (clients) {
      const clientsById = clients.reduce(
        (a, c) => a.set(c.get("uid"), c),
        Im.Map(),
      );
      const sharedWithClientIds = product?.shares || [];
      const shares = sharedWithClientIds.reduce(
        (a, _id) =>
          clientsById.get(_id) ? a.set(_id, clientsById.get(_id)) : a,
        Im.Map(),
      );
      setShares(shares);
    }
  }, [clients, product]);

  if (isLoadingClients) {
    return <BasicSpinner />;
  }

  const options = clients
    .map((client, i) => (
      <option key={i} value={client.get("uid")}>
        {client.get("name")}
      </option>
    ))
    .unshift(
      <option key={-1} value="">
        Select a client to share with
      </option>,
    );

  return (
    <Modal title={`Share with clients - ${product.details.name}`}>
      <SharesList shares={shares} setShares={setShares} />
      <hr />
      <select
        value=""
        className="form-control"
        onChange={(e) => {
          const clientId = e.target.value;
          const client = clients.find(
            (client) => client.get("uid") === clientId,
          );
          setShares(shares.set(clientId, client));
        }}
      >
        {options}
      </select>
      <button
        className="btn btn-sm btn-outline-primary float-right mt-3"
        onClick={() =>
          updateShares({
            companyId,
            product,
            shares: shares.toList()?.toJS(),
            onSuccess: _onSuccess,
          })
        }
      >
        Save
      </button>
    </Modal>
  );
}

function ShareProductButton({ companyId, product, onSuccess }) {
  console.log("ShareProductButton", companyId, product);
  const { setModal } = useModal();
  return (
    <span
      style={{ cursor: "pointer" }}
      className="float-right"
      onClick={(e) =>
        setModal(
          <ShareProductModal
            companyId={companyId}
            product={product}
            onSuccess={onSuccess}
          />,
        )
      }
    >
      <Octicon name="mail-reply" />
    </span>
  );
}

function CopyProductToDraftButton({ companyId, product, onSuccess }) {
  const { push } = useHistory(); // Accessing app history

  // Action after clicking "Copy product" button
  const handleCopyToDraft = async () => {
    const response = await fetcher(
      `${CCP_API_URL}/${companyId}/product/draft/`,
      "POST", // Creating new draft
      {
        // Populate the new draft with data from the existing product
        details: { ...product.details },
      },
    );
    // Getting new ID for the new draft
    const draftId = response.payload.get("id");
    // Going to the new draft with newly created ID
    push(`/company/${companyId}/asset/draft/${draftId}`);
    onSuccess();
  };

  return (
    <span
      style={{ cursor: "pointer" }}
      className="float-right"
      onClick={handleCopyToDraft}
    >
      <Octicon name="diff" />
    </span>
  );
}

function AssetRow({ type = "draft", companyId, sharedAsset }) {
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDelete = () => {};

  // Get the product drafts (from CCP API)
  console.log("AssetRow", `${CCP_API_URL}/${companyId}/product/${type}/`);

  const { data, isLoading, trigger } = useApi(
    `${CCP_API_URL}/${companyId}/product/${type}/`,
  );

  if (isLoading) {
    return (
      <tr>
        <td>
          <BasicSpinner />
        </td>
      </tr>
    );
  }

  if (!data || data?.size < 1)
    return type == "draft" ? ( // if its a draft render different message
      <p className="text-muted text-center">
        You have no draft assets yet. Create a new draft asset to see it here.
      </p>
    ) : (
      <p className="text-muted text-center">
        You have no assets yet. Create and Submit a draft asset to see it here.
      </p>
    );
  console.log(data?.toJS(), "dataPure");

  if (type !== "draft" && data?.size > 0) {
    console.log(data?.toJS(), "");
    return (
      <div className="">
        <button
          className="btn btn-sm btn-primary float-right align-text-top"
          onClick={async () => {
            const workbook = exportToXLS({ data: data.toJS() });
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
              type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, "PCC catalogue.xlsx");
          }}
        >
          Export catalogue to XLS
        </button>
        <CatalogTable
          data={data}
          isLoading={isLoading}
          companyId={companyId}
          onSuccess={trigger}
          type={type}
          ShareProductButton={ShareProductButton}
          CopyProductToDraftButton={CopyProductToDraftButton}
          sharedAsset={sharedAsset}
        />
      </div>
    );
  }

  return data?.map((p) => {
    console.log("Got data p = ", p, data);
    if (!Im.isImmutable(p)) {
      return null;
    }
    const _id = p.get(`${type}_id`);
    const name =
      p.getIn(["details", "name"]) || (type == "draft" ? "Draft" : "");
    return (
      <tr key={_id}>
        <Link to={`/company/${companyId}/asset/${type}/${_id}`}>
          <td>
            <span className="btn-link" type="submit">
              {name}
            </span>
          </td>
        </Link>

        {type == "draft" ? (
          <td>
            <Link to={`/company/${companyId}/asset/draft/${_id}`}>
              <span className="mx-3 float-right">
                <Octicon name="pencil" /> Edit
              </span>
            </Link>
            {/* The below <a> tag is used for styling the Delete button */}
            <a href="#!">
              <span
                className="mx-3 float-right "
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDeleteModal();
                }}
              >
                <Octicon name="trashcan" /> Delete
              </span>
            </a>

            {/* Submission Confirmation Modal */}
            <div
              className={`modal fade ${deleteModal ? "show" : ""}`}
              style={{ display: deleteModal ? "flex" : "none" }}
              tabIndex="-1"
              role="dialog"
            >
              <div
                className="modal-dialog modal-dialog-centered justify-content-center"
                role="document"
              >
                <div className="modal-content ">
                  <div className="modal-header border-0">
                    <h4 className="modal-title mt-3 w-100">
                      <Octicon
                        className="text-danger h1 mr-2"
                        name="stop"
                        mega
                      />
                      Confirm deletion
                    </h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={toggleDeleteModal}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Are you sure you want to delete this draft? This action
                      cannot be undone.
                    </p>

                    <br />
                  </div>
                  <div className="modal-footer border-0">
                    <button
                      type="button"
                      className="btn btn-link"
                      data-dismiss="modal"
                      onClick={toggleDeleteModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={async () => {
                        toggleDeleteModal();
                        await fetcher(
                          `${CCP_API_URL}/${companyId}/product/draft/${_id}`,
                          "DELETE",
                          {},
                        );
                        trigger();
                      }}
                    >
                      Yes, delete
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {deleteModal && <div className="modal-backdrop fade show" />}
          </td>
        ) : null}
      </tr>
    );
  });
}

function Catalog({}) {
  // Get the list of the users' companies (from Track API) - this may not be needed here
  const router = useHistory();

  const { companyId } = useParams();
  const { data: company, isLoading } = useApi(`/api/company/${companyId}/`);

  // Wait for the data

  return (
    <div className="container mt-5">
      {/* <Link to={`/`}>
        <button className="btn btn-link text-muted">
          <p
            className="text-muted text-underline mb-5"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Octicon name="chevron-left" />
            Back to companies list
          </p>
        </button>
      </Link> */}

      <div className="mb-5">
        <h2 className=" font-weight-bold">
          {company?.get("name")}
          <Link to={`/company/${companyId}`}>
            <button className="btn btn-sm btn-outline-secondary float-right">
              Company settings <Octicon name="gear" />
            </button>
          </Link>
        </h2>
      </div>
      <div>
        <h3>Sustainability Tool - Embodied carbon of assets</h3>
        <p>
          Welcome to the Embodied Carbon Calculator, a dedicated module within
          the Sustainability Tool. This feature is designed to assist you, along
          with your customers and suppliers, in calculating and sharing the
          carbon footprint associated with your assets and products. Explore the
          various sections below to navigate through your asset catalogues.
        </p>

        <p>
          For any support or enquiries, please don't hesitate to get in touch
          with our team at{" "}
          <a href="mailto:info@sustainabilitytool.com">
            info@sustainabilitytool.com
          </a>
          .
        </p>
      </div>
      <div className="card shadow p-3 my-5 bg-white rounded border-0">
        <h3 className="my-3 p-2">
          Draft assets
          <button
            className="btn btn-sm btn-primary float-right align-text-top"
            onClick={async () => {
              const response = await fetcher(
                `${CCP_API_URL}/${companyId}/product/draft/`,
                "POST",
                {
                  details: {
                    mass: 0,
                    company_name: company.get("name"),
                    moduleSubmissions: {
                      a1: [{}],
                      a2: [{}],
                      a3: [{}],
                      a4: [{}],
                      b8: {
                        mass: 0,
                        leak_rate: 0,
                        gas_type: "",
                        gwp: 0,
                        leak_mass: 0,
                        lifetime: 0,
                        annual_losses: 0,
                        total_kgco2e_lifetime: 0,
                      },
                    },
                  },
                },
              );
              const draftId = response.payload.get("id");
              router.push(`/company/${companyId}/asset/draft/${draftId}`);
            }}
          >
            Create new draft asset
            <Octicon className="ml-2 pt-1" name="plus" />
          </button>
        </h3>
        <p className="text-muted">
          This area displays all your assets currently in draft form. You can
          select any draft asset to finalise its details and submit it to your
          company's catalogue. Note that assets in draft status are not visible
          to clients.
        </p>
        <table className="table table">
          <tbody>
            <AssetRow type="draft" companyId={companyId} />
          </tbody>
        </table>
      </div>

      <div className="card shadow p-3 mb-5 bg-white rounded border-0">
        <h3 className="my-3 p-2">Your assets</h3>
        <p className="text-muted">
          Here, you'll find a list of all the assets you've shared with your
          clients. While these assets cannot be edited directly, you have the
          option to copy them to drafts for the creation of new assets. Use the
          share button to manage client sharing preferences.
        </p>

        <AssetRow type="product" companyId={companyId} />
      </div>

      <div className="card shadow p-3 mb-5 bg-white rounded border-0">
        <h3 className="my-3 p-2">Supplier assets</h3>
        <p className="text-muted">
          This section catalogues all the assets shared with you by your
          suppliers.
        </p>
        <AssetRow type="catalog" companyId={companyId} sharedAsset />
      </div>
    </div>
  );
}

export default Catalog;
